import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import {
    QUOTE_TYPES,
    addDisclosureContainerAfterSureHits,
    addSureHitsContainerAfterReactDOM,
} from '../Helpers/surehits';

const addScriptToDOM = (conf, target) => {
    // create initial script here to avoid loading surehits prior to thankyou page
    const initScript = document.createElement('script');
    initScript.type = 'text/javascript';
    initScript.src = '//www.nextinsure.com/listingdisplay/loader/sh';
    document.body.appendChild(initScript);

    const intervalId = setInterval(() => {
        if (typeof sh !== 'undefined') {
            clearInterval(intervalId);
            // create script to perform surehits request
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.innerText = `sh.initialize(${JSON.stringify(conf)}, "${target}");`;
            document.body.appendChild(script);
        }
    }, 1);
};

// type can be personal or commercial
const SureHits = ({ type, useFormData, leadSource, children }) => {
    const sureHitsContainerRef = useRef(null);
    const [disclosureContainerRef, setDisclosureContainerRef] = useState(null);
    const isCommercialQuote = type === QUOTE_TYPES.COMMERCIAL;

    const [formData] = useFormData();

    useEffect(() => {
        if (type === QUOTE_TYPES.PERSONAL) {
            const sureHitsContainer = addSureHitsContainerAfterReactDOM(); // Add surehits container after the React DOM element
            const disclosureElm = addDisclosureContainerAfterSureHits(sureHitsContainer); // Add disclosure container after the surehits container

            // Save the surehits container and disclosure container refs to be used by react
            sureHitsContainerRef.current = sureHitsContainer;
            if (disclosureElm && !disclosureContainerRef) {
                setDisclosureContainerRef(disclosureElm); // saving to state allows the ui to re-render when the disclosure container is added
            }

            // Cleanup function to remove the div when the component unmounts
            return () => {
                if (sureHitsContainerRef.current) {
                    sureHitsContainerRef.current.remove();
                }
                if (disclosureContainerRef) {
                    disclosureContainerRef.remove();
                }
            };
        }
    }, []);

    useEffect(() => {
        const handleCommercialSubmit = async () => {
            // on submit, go to quote confirmation and set global data for surehits
            const { zipcode, id: leadId, insurance_types = [], sicCode } = formData;

            // Extract `id` from insurance_types array
            let insuranceTypes = insurance_types.map(type => type.id);

            const data = {
                business_owners_package_policy: insuranceTypes.includes(10) ? '1' : '0',
                commercial_auto: insuranceTypes.includes(3) ? '1' : '0',
                commercial_property: insuranceTypes.includes(8) ? '1' : '0',
                general_liability: insuranceTypes.includes(1) ? '1' : '0',
                group_health: insuranceTypes.includes(35) ? '1' : '0',
                key_man_disability: insuranceTypes.includes(34) ? '1' : '0',
                key_man_life: insuranceTypes.includes(34) ? '1' : '0',
                professional_liability: insuranceTypes.includes(7) ? '1' : '0',
                src: '662545',
                standard_industry_code: !!sicCode ? sicCode : '',
                var1: `${leadSource}|lead_id=${leadId}`,
                workers_compensation: insuranceTypes.includes(9) ? '1' : '0',
                zipcode: zipcode,
            };

            setTimeout(() => addScriptToDOM(data, 'qsWidgetContainer'), 1);
        };

        const handlePersonalSubmit = async () => {
            const { zipcode, insurance_types } = formData;

            const surehitsData = {
                src: leadSource,
                zipcode,
                var1: leadSource,
            };
            addScriptToDOM(surehitsData, 'qsWidgetContainer');
        };

        type === QUOTE_TYPES.PERSONAL ? handlePersonalSubmit() : handleCommercialSubmit();
    }, [type]);

    return (
        <>
            <noscript>
                <img
                    src="//create.leadid.com/noscript.gif?lac=88378C51-7970-7B90-3609-FF7B36CF3175&lck=3d2e98ad-519d-f0de-3c86-015895bb9611&snippet_version=2"
                    alt="Lead Id"
                />
            </noscript>
            {isCommercialQuote && (
                <div
                    id="qsWidgetContainer"
                    className="surehits-custom"
                    data-testid="surehits-container"
                    data-quote-type={type}
                ></div>
            )}
            {disclosureContainerRef && ReactDOM.createPortal(children, disclosureContainerRef)}
        </>
    );
};

export default SureHits;
